<div>
  <a *ngFor="let item of array; let i = index" [routerLink]="getLink(item)" [attr.rel]="'nofollow'">{{item[label]}}<span *ngIf="i < array.length - 1">, </span></a>
</div>
